var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "text-no-wrap"
  }, [_c('v-col', [_vm._v(" 등록일 : " + _vm._s(_vm.createdAt) + " ")]), _c('v-col', [_vm._v(" 서명일 : " + _vm._s(_vm.signedAt) + " ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }